<ng-container>
  <div class="conflict__list__description">
    <div class="conflict__list__description--layout">
      <div class="iconWrapper">
        <pp-icon
          [ppSrc]="EIconPath.ICON_BANNER_COPY_MOVE_INFO"
          [ppDisplayContents]="true"
        ></pp-icon>
      </div>

      <div>
        @if (ppPointPinsToBeCentered) {
          <div
            class="conflict__list-header conflict__list-info conflict__list-info--first"
            >
            <span>
              {{ 'site_plans_different' | ppTranslate }}
            </span>
          </div>
        }

        <div class="conflict__list-header conflict__list-info">
          <p>{{ 'information_transfer_1' | ppTranslate }}</p>

          <ul class="conflict__list">
            <li>{{ 'information_transfer_2' | ppTranslate }}</li>
            <li>{{ 'information_transfer_3' | ppTranslate }}</li>
            <li>{{ 'information_transfer_4' | ppTranslate }}</li>
          </ul>

          <p>
            {{ 'information_transfer_5_copy' | ppTranslate }}<br />
            {{ 'information_transfer_6' | ppTranslate }}
          </p>
        </div>
      </div>
    </div>

    @if (ppFieldConflicts?.length) {
      <div class="conflict__list-header conflict__list-header--site">
        <p>
          {{ 'copy_move_conflict_1' | ppTranslate }}
          <span class="conflict__list-header--bold">{{ ppSelectedWorkspaceName }}</span>
          {{ 'copy_move_points_to_the_site' | ppTranslate }}:
        </p>
        @if (ppFieldConflicts?.length) {
          <ul class="conflict__list-fields">
            @for (fieldConflict of ppFieldConflicts; track fieldConflict) {
              <li class="conflict__list-item mainBody">
                @switch (fieldConflict.type) {
                  @case (EBasicField.TAGS) {
                    <pp-icon
                      class="conflictImage"
                      [ppSrc]="EIconPath.ICON_ACTIVITIES_TAGS_14"
                      [ppDisplayContents]="true"
                      ppColor="grey-500"
                      />
                  }
                  @case (ECustomFieldType.LIST) {
                    <pp-icon
                      class="conflictImage"
                      [ppSrc]="EIconPath.ICON_FIELDS_LIST_14"
                      [ppDisplayContents]="true"
                      ppColor="grey-500"
                      />
                  }
                  @case (ECustomFieldType.MULTI_LIST) {
                    <pp-icon
                      class="conflictImage"
                      [ppSrc]="EIconPath.ICON_FIELDS_MULTI_LIST_14"
                      [ppDisplayContents]="true"
                      ppColor="grey-500"
                      />
                  }
                  @case (ECustomFieldType.PERCENTAGE) {
                    <pp-icon
                      class="conflictImage"
                      [ppSrc]="EIconPath.ICON_FIELDS_PERCENTAGE_14"
                      [ppDisplayContents]="true"
                      ppColor="grey-500"
                      />
                  }
                  @case (ECustomFieldType.FORMULA) {
                    <pp-icon
                      class="conflictImage"
                      [ppSrc]="EIconPath.ICON_FIELDS_FORMULA_14"
                      [ppDisplayContents]="true"
                      ppColor="grey-500"
                      />
                  }
                  @case (ECustomFieldType.NUMBERS) {
                    <pp-icon
                      class="conflictImage"
                      [ppSrc]="EIconPath.ICON_FIELDS_NUMBERS_14"
                      [ppDisplayContents]="true"
                      ppColor="grey-500"
                      />
                  }
                  @case (ECustomFieldType.COST) {
                    <pp-icon
                      class="conflictImage"
                      [ppSrc]="EIconPath.ICON_FIELDS_COST_14"
                      [ppDisplayContents]="true"
                      ppColor="grey-500"
                      />
                  }
                  @case (ECustomFieldType.TIME) {
                    <pp-icon
                      class="conflictImage"
                      [ppSrc]="EIconPath.ICON_FIELDS_TIME_14"
                      [ppDisplayContents]="true"
                      ppColor="grey-500"
                      />
                  }
                  @case (ECustomFieldType.DATE) {
                    <pp-icon
                      class="conflictImage"
                      [ppSrc]="EIconPath.ICON_FIELDS_DATE_14"
                      [ppDisplayContents]="true"
                      ppColor="grey-500"
                      />
                  }
                  @case (ECustomFieldType.CHECKBOX) {
                    <pp-icon
                      class="conflictImage"
                      [ppSrc]="EIconPath.ICON_FIELDS_CHECKBOX_14"
                      [ppDisplayContents]="true"
                      ppColor="grey-500"
                      />
                  }
                  @case (ECustomFieldType.RICHTEXT) {
                    <pp-icon
                      class="conflictImage"
                      [ppSrc]="EIconPath.ICON_FIELDS_RICH_TEXT_14"
                      [ppDisplayContents]="true"
                      ppColor="grey-500"
                      />
                  }
                  @case (ECustomFieldType.TEXT) {
                    <pp-icon
                      class="conflictImage"
                      [ppSrc]="EIconPath.ICON_FIELDS_TEXT_14"
                      [ppDisplayContents]="true"
                      ppColor="grey-500"
                      />
                  }
                  @case (ECustomFieldType.TIMELINE) {
                    <pp-icon
                      class="conflictImage"
                      [ppSrc]="EIconPath.ICON_FIELDS_TIMELINE_14"
                      [ppDisplayContents]="true"
                      ppColor="grey-500"
                      />
                  }
                }
                {{ fieldConflict.name }}
              </li>
            }
          </ul>
        }
      </div>
    }
  </div>
</ng-container>
